// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header[data-v-7b036d21] {\n  display: flex;\n  align-items: center;\n  color: #53B0A3;\n  margin-bottom: 0.2rem;\n}\n.header .headerP1[data-v-7b036d21] {\n    margin-right: 0.2rem;\n}\n", ""]);
// Exports
module.exports = exports;
